<template>
  <div class="home">
    <div class="d-flex">
      <div class="item" @click="fetchModel">
        <span class="title">Tổng lượt truy cập web:</span>
        <span class="count">{{ modelData.view_txt }}</span>
      </div>
      <div class="item green" @click="updateSetting">
        <span class="title">Lượt mới</span>
        <span class="count d-flex align-items-center">
          <span>{{ modelData.view_old_txt }}</span>
          <i class="far fa-trash-alt"></i>
        </span>
      </div>
    </div>
    <el-row>
      <h2>Biểu đồ lượt đăng kí mới tài khoản</h2>
      <div class="model-filter">
        <el-col :span="8">
          <div class="input-daterange">
            <el-date-picker
              v-model="filter.date"
              @change="changeDateStatistic"
              type="daterange"
              value-format="yyyy-MM-dd"
              format="dd/MM/yyyy"
              range-separator="tới"
              start-placeholder="Ngày bắt đầu"
              end-placeholder="Ngày kết thúc"
              :picker-options="pickerOptions2">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="10">
        </el-col>
        <el-col :span="6">
          <div class="dashboard-panigation d-flex flex-end">
              <div class="list-item-limit d-flex">
                <div
                  :class="[filter.view == 'day' ? 'active' : '']"
                  class="item-limit firt-item" @click="changeTimeFormart('day')">
                  <span>Ngày</span>
                </div>
                <div
                  :class="[filter.view == 'month' ? 'active' : '']"
                  class="item-limit" @click="changeTimeFormart('month')">
                  <span>Tháng</span>
                </div>
                <div
                  :class="[filter.view == 'year' ? 'active' : '']"
                  class="item-limit last-item" @click="changeTimeFormart('year')">
                  <span>Năm</span>
                </div>
              </div>
          </div>
        </el-col>
      </div>
      <div>
        <div id="statitic" v-loading="loading">
          <highcharts :options="chartOptions"></highcharts>
        </div>
        <div id="statitic2" v-loading="loading2" v-if="accountInfo.domain_id == 1">
          <highcharts :options="chartOptions2"></highcharts>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import {Chart} from 'highcharts-vue'
export default {
  name: 'HomeIndex',
  components: {
    highcharts: Chart
  },
  metaInfo () {
    return {
      title: 'Trang chủ'
    }
  },
  data () {
    return {
      loading: false,
      loading2: false,
      modelData: {

      },
      filter: {
        view: 'month',
        date: ''
      },
      chartOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Biểu đồ lượt đăng kí mới tài khoản'
        },
        subtitle: {
          text: ''
        },
        xAxis: {
          categories: [
          ],
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Số lượt'
          },
          labels: {
            overflow: 'justify'
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          valueSuffix: ' lượt'
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true
            }
          }
        },
        credits: {
          enabled: true
        },
        series: [
          {
            name: 'Số lượt',
            data: []
          }
        ]
      },
      chartOptions2: {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Biểu đồ tổng tiền thu được (đơn vị: triệu đồng)'
        },
        subtitle: {
          text: ''
        },
        xAxis: {
          categories: [
          ],
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Số tiền'
          },
          labels: {
            overflow: 'justify'
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          valueSuffix: ' triệu'
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true
            }
          }
        },
        credits: {
          enabled: true
        },
        series: [
          {
            name: 'Số lượt',
            data: []
          }
        ]
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: 'Hôm nay',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '3 ngày trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '7 ngày trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '14 ngày trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '1 Tháng trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '3 Tháng trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '6 Tháng trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '1 năm trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '2 năm trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365 * 2)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '5 năm trước',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365 * 5)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['path']),
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
    this.initDateCurrent()
    this.fetchSatistic()
  },
  methods: {
    initDateCurrent () {
      let start = new Date()
      let ddstart = String(start.getDate()).padStart(2, '0')
      let mmstart = String(start.getMonth() + 1).padStart(2, '0')
      let yyyystart = start.getFullYear()
      let datestart = yyyystart + '-' + mmstart + '-' + ddstart

      var end = new Date()
      end.setDate(end.getDate() - 180)
      let ddend = String(end.getDate()).padStart(2, '0')
      let mmend = String(end.getMonth() + 1).padStart(2, '0')
      let yyyyend = end.getFullYear()
      let dateend = yyyyend + '-' + mmend + '-' + ddend

      this.filter.date = [dateend, datestart]
    },
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.post('settings/get-setting').then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateSetting () {
      let data = {
        'view_old': this.modelData.view
      }
      axios.put('settings/' + this.modelData.id, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Reset lượt mới thành công',
              type: 'success'
            })
            this.modelData.view_old_txt = 0
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSatistic () {
      this.loading = true
      axios.post('statistics/user-by-time', this.filter).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.chartOptions.xAxis.categories = response.data.categories
            this.chartOptions.series[0].data = response.data.series

            this.loading2 = true
            if (this.accountInfo.domain_id === 1) {
              setTimeout(() => {
                this.fetchSatistic2()
              }, 1500)
            }
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSatistic2 () {
      axios.post('statistics/money-by-time', this.filter).then(response => {
        this.loading2 = false
        switch (response.code) {
          case 200:
            this.chartOptions2.xAxis.categories = response.data.categories
            this.chartOptions2.series[0].data = response.data.series
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    changeDateStatistic () {
      this.fetchSatistic()
    },
    changeTimeFormart (time) {
      this.filter.view = time
      this.fetchSatistic()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.home {
  margin-top: 15px;
}
.item {
  cursor: pointer;
  border-radius: 6px;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 125px;
  width: 200px;
  background: rgb(0, 168, 255);
  margin-right: 15px;
}
.green {
  background: #27ae60
}
.title {
  font-size: 16px;
  color: #fff;
}
.count {
  font-size: 25px;
  color: #fff;
  margin-top: 5px
}
.count i {
  font-size: 14px;
  margin-left: 5px;
}
#statitic {
  background: #fff;
  min-height: 500px;
  padding-top: 25px;
}
.dashboard-panigation {
  padding: 15px 25px;
}

.dashboard-panigation .list-item-limit {
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.dashboard-panigation .item-limit {
  color: #121212;
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  cursor: pointer;
  padding: 8px 30px;
  transition: all 0.3s;
  borderradius: 10px;
}
.dashboard-panigation .item-limit:hover {
  background: #A5DFF9;
  transition: all 0.3s;
}
.dashboard-panigation .item-limit.active {
  background: #A5DFF9;
}

.dashboard-panigation .item-limit.firt-item {
  border-right: 1px solid #29A1DA;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.dashboard-panigation .item-limit.last-item {
  border-left: 1px solid #29A1DA;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/IndexAdmin.vue